import React from 'react';
import { Link } from 'react-router-dom';
import ServiceLayout from '../components/ServiceLayout.jsx';

const OnlineSessioner = () => {
  return (
    <ServiceLayout 
      title="Online sessioner"
      subtitle="Terapi i dine egne trygge rammer – uanset hvor du bor."
      image="https://assets.auxodev.dk/assets/c5965315-775d-45c8-ad9e-70e7ef29846e/fab2babc-23ca-4f31-8099-83e406c6ac30.png"
      description="Online sessioner er et populært valg for mange, da det sparer transporttid og giver mulighed for at modtage behandling i vante omgivelser. Metakognitiv terapi fungerer fremragende via skærmen, da fokus er på dialog og de værktøjer, du skal bruge i din hverdag."
      benefits={[
        "Ingen transporttid eller parkering",
        "Tryghed i eget hjem",
        "Samme høje kvalitet som fysisk fremmøde",
        "Fleksibilitet i en travl hverdag"
      ]}
      content={[
        "Booking: Du vælger en tid i online-kalenderen, der passer dig.",
        "Teknik: Du modtager et sikkert link til vores videomøde før sessionen.",
        "Forløb: Vi gennemgår samme struktur og øvelser som i klinikken.",
        "Opfølgning: Vi sikrer, at teknikken virker, så vi kan fokusere på dig."
      ]}
      metaDescription="Modtag metakognitiv terapi online hos Lars Nissen Corell – Psykoterapeut MPF. Fleksibelt, sikkert og lige så effektivt som fysiske sessioner."
    >
      <div className="mt-20 mb-20 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="order-1 md:order-2">
          <h2 className="text-3xl font-serif text-[#123F13] mb-6">Fleksibilitet og tryghed i din hverdag</h2>
          <div className="space-y-4 text-[#3B352F]/70 text-lg leading-relaxed">
            <p>
              Online terapi giver dig friheden til at arbejde med dine udfordringer, uanset hvor du befinder dig. Det kræver blot en stabil internetforbindelse og et roligt sted, hvor du kan tale uforstyrret.
            </p>
            <p>
              Mange af mine klienter oplever, at det er lettere at åbne op og implementere de metakognitive værktøjer, når de sidder i deres egne vante omgivelser. Det fjerner stressfaktorer som transport og parkering, så du kan gå direkte fra sessionen til din hverdag med fornyet ro.
            </p>
            <p className="text-base border-l-2 border-[#8C2F12]/30 pl-4 py-1">
              Dette gælder også for parterapi og relationscoaching. Hvis I har en travl hverdag eller bor forskellige steder, kan I med fordel modtage <Link to="/parterapi" className="text-[#8C2F12] font-semibold hover:underline">parterapi online</Link> og arbejde med jeres relation i trygge rammer.
            </p>
            <p className="text-base border-l-2 border-[#8C2F12]/30 pl-4 py-1">
              For autistiske personer kan online sessioner være en stor lettelse, da det fjerner transportstress, nye sanseindtryk og uforudsigelighed. Læs mere om mit <Link to="/autismevenlig-terapi" className="text-[#8C2F12] font-semibold hover:underline">autismevenlige forløb</Link>.
            </p>
          </div>
        </div>
        <div className="order-2 md:order-1 relative aspect-square rounded-2xl overflow-hidden shadow-lg border border-[#E8DDCE]">
          <img 
            src="https://assets.auxodev.dk/assets/c5965315-775d-45c8-ad9e-70e7ef29846e/2bc23849-c968-40f1-94e0-326b613ee952.png" 
            alt="Online session hos Lars Nissen Corell – Psykoterapeut MPF" 
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </ServiceLayout>
  );
};

export default OnlineSessioner;
